import { render, staticRenderFns } from "./pelatihan_sertifikat.vue?vue&type=template&id=332a7b16"
import script from "./pelatihan_sertifikat.vue?vue&type=script&lang=js"
export * from "./pelatihan_sertifikat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports